module.exports = __webpack_public_path__ + "assets/assets/images/home/dentists-page-3.0a3f2cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/dentists-page-3.svg
// module id = 215
// module chunks = 0